import React, { useState } from 'react';
import { Card, CardBody, Badge, Button } from 'reactstrap';

const TokenStatusCard = ({ token, onTokenRenewed, onManualRenewal }) => {
  const [isRenewing, setIsRenewing] = useState(false);

  const getStatusConfig = (status) => {
    switch (status) {
      case 'active':
        return {
          icon: '✅',
          color: 'success',
          label: 'ATTIVO',
          btnClass: 'btn-outline-success',
        };
      case 'warning':
        return {
          icon: '⚠️',
          color: 'warning',
          label: 'IN SCADENZA',
          btnClass: 'btn-warning',
        };
      case 'critical':
        return {
          icon: '🚨',
          color: 'danger',
          label: 'CRITICO',
          btnClass: 'btn-danger',
        };
      case 'expired':
        return {
          icon: '❌',
          color: 'dark',
          label: 'SCADUTO',
          btnClass: 'btn-danger',
        };
      default:
        return {
          icon: '❓',
          color: 'secondary',
          label: 'SCONOSCIUTO',
          btnClass: 'btn-secondary',
        };
    }
  };

  const statusConfig = getStatusConfig(token.status);

  const handleRenewToken = async () => {
    setIsRenewing(true);

    try {
      // Metodo OAuth Automatico
      const renewUrl = `${process.env.REACT_APP_FUNCTIONS_URL}/ws/facebook/auth/${token.countryId}`;

      // Apri in una nuova finestra
      const popup = window.open(
        renewUrl,
        'facebook-oauth',
        'width=600,height=700,scrollbars=yes,resizable=yes',
      );

      // Monitora la chiusura del popup
      const checkClosed = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkClosed);
          setIsRenewing(false);
          // Ricarica i dati dei token
          onTokenRenewed();
        }
      }, 1000);
    } catch (error) {
      console.error('Errore nel rinnovo token:', error);
      setIsRenewing(false);
      alert('Errore nel rinnovo del token. Riprova più tardi.');
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  const getButtonText = () => {
    if (isRenewing) return '🔄 Rinnovando...';
    if (token.status === 'expired') return '🚨 Rinnova Subito';
    if (token.status === 'critical') return '⚠️ Rinnova Ora';
    if (token.status === 'warning') return '📅 Rinnova';
    return '🔄 Rinnova Token';
  };

  return (
    <Card
      className={`border-left border-${statusConfig.color} h-100`}
      style={{
        borderLeftWidth: '4px',
        transition: 'transform 0.2s, box-shadow 0.2s',
      }}>
      <CardBody>
        <div className="d-flex justify-content-between align-items-start mb-3">
          <div>
            <h5 className="mb-1">
              {statusConfig.icon} {token.countryId}
            </h5>
          </div>
          <Badge color={statusConfig.color} className="font-size-12">
            {statusConfig.label}
          </Badge>
        </div>

        <div>
          <div className="mb-2">
            <small className="text-muted d-block">Data di scadenza</small>
            <span className="font-weight-medium">
              {formatDate(token.expirationDate)}
            </span>
          </div>

          <div className="mb-2">
            <small className="text-muted d-block">Giorni rimanenti</small>
            <h4 className={`mb-0 text-${statusConfig.color}`}>
              {token.daysUntilExpiration}
            </h4>
          </div>

          {token.lastUpdated && (
            <div className="mb-3">
              <small className="text-muted d-block">Ultimo aggiornamento</small>
              <small>{formatDate(token.lastUpdated)}</small>
            </div>
          )}
        </div>

        <div className="mt-3">
          <Button
            color={statusConfig.btnClass.replace('btn-', '')}
            className="w-100 mb-2"
            onClick={handleRenewToken}
            disabled={isRenewing}>
            {getButtonText()}
          </Button>

          {onManualRenewal && (
            <Button
              color="secondary"
              outline
              className="w-100"
              onClick={() => onManualRenewal(token.countryId)}
              disabled={isRenewing}>
              <i className="bx bx-wrench mr-1"></i>
              Rinnovo Manuale
            </Button>
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default TokenStatusCard;
